import { render, staticRenderFns } from "./IconPickerComponent.vue?vue&type=template&id=099deaf2&"
import script from "./IconPickerComponent.vue?vue&type=script&lang=js&"
export * from "./IconPickerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports